import MomentUtils from '@date-io/moment'
import moment from 'moment'
import 'moment/locale/pt-br'
import React, { useContext, useEffect, useState } from 'react'

import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import CurrencyInput from 'react-currency-input'
import uuid from 'uuid/v4'

import Context from '../../context'
import { ParserEventsPricing } from '../../helpers/EventValuesHelper'

moment.locale('pt-br')

function EventsValuesData() {
  const { formObject, setFormObject, eventsValuesList, setEventsValuesList } = useContext(Context)

  const [fullMaskedValue, setFullMaskedValue] = useState('0,00')
  const [clubMaskedValue, setClubMaskedValue] = useState('0,00')

  const handleAddItem = () => {
    const newObject = {
      id: uuid(),
      lot: '',
      startDate: new Date(),
      endDate: new Date(),
      section: '',
      fullValue: '0,00',
      clubValue: '0,00'
    }
    setEventsValuesList([...eventsValuesList, newObject])
  }

  const handleDeleteItem = id => {
    const newArr = eventsValuesList.filter(item => {
      return item.id !== id
    })

    setEventsValuesList(newArr)
  }

  const changeItem = (key, value, id) => {
    const newArr = eventsValuesList.map(item => {
      if (item.id === id) {
        const newItem = item
        newItem[key] = value
        return { ...newItem }
      }
      return { ...item }
    })
    setEventsValuesList([...newArr])
  }

  const handleChangeDate = (key, id) => date => {
    changeItem(key, date, id)
  }

  const getValue = (id, key) => {
    const obj = eventsValuesList.find(item => item.id === id)
    return obj[key]
  }

  const handleFullValueChange = (event, maskedvalue, floatvalue) => {
    setEventsValuesList(list => {
      return list.map(item => {
        if (`fullValue-${item.id}` === event.target.id) {
          return { ...item, fullValue: floatvalue, maskedvalue }
        }
        return item
      })
    })
  }

  const handleClubValueChange = (event, maskedvalue, floatvalue) => {
    setEventsValuesList(list => {
      return list.map(item => {
        if (`clubValue-${item.id}` === event.target.id) {
          return { ...item, clubValue: floatvalue, maskedvalue }
        }
        return item
      })
    })
  }

  useEffect(() => {
    setFormObject({
      ...formObject,
      eventsPricing: ParserEventsPricing(eventsValuesList)
    })
  }, [eventsValuesList])

  return (
    <>
      <h5>Informações sobre Vendas</h5>
      <div className="row">
        {eventsValuesList.length > 0 &&
          eventsValuesList.map(item => (
            <div key={`${item.id}`} className="col-12" style={{ marginBottom: 10 }}>
              <div className="card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-6" style={{ padding: 5 }}>
                      <div className="form-group ">
                        <label htmlFor={`lot-${item.id}`}>Lote</label>
                        <input
                          value={item.lot}
                          onChange={e => changeItem('lot', e.target.value, item.id)}
                          id={`lot-${item.id}`}
                          type="number"
                          className="form-control"
                          placeholder="Lote"
                        />
                      </div>
                    </div>
                    <div className="col-6" style={{ padding: 5 }}>
                      <div className="form-group ">
                        <label htmlFor={`section-${item.id}`}>Setor</label>
                        <input
                          value={item.section}
                          onChange={e => changeItem('section', e.target.value, item.id)}
                          id={`section-${item.id}`}
                          type="text"
                          className="form-control"
                          placeholder="Setor"
                        />
                      </div>
                    </div>
                    <div className="col-6" style={{ padding: 5 }}>
                      <div className="form-group ">
                        <label htmlFor={`fullValue-${item.id}`}>Valor sem desconto</label>
                        <CurrencyInput
                          value={getValue(item.id, 'fullValue')}
                          onChangeEvent={handleFullValueChange}
                          id={`fullValue-${item.id}`}
                          className="form-control"
                          decimalSeparator=","
                          thousandSeparator="."
                          prefix="R$ "
                        />
                      </div>
                    </div>
                    <div className="col-6" style={{ padding: 5 }}>
                      <div className="form-group ">
                        <label htmlFor={`clubValue-${item.id}`}>Valor para o Clube</label>
                        <CurrencyInput
                          value={getValue(item.id, 'clubValue')}
                          onChangeEvent={handleClubValueChange}
                          id={`clubValue-${item.id}`}
                          className="form-control"
                          decimalSeparator=","
                          thousandSeparator="."
                          prefix="R$ "
                        />
                      </div>
                    </div>
                    <div
                      className="col-6 d-flex flex-row justify-content-between"
                      style={{ padding: 5 }}
                    >
                      <div style={{ paddingRight: 2 }}>
                        <MuiPickersUtilsProvider
                          libInstance={moment}
                          utils={MomentUtils}
                          locale="pt-br"
                        >
                          <KeyboardDatePicker
                            margin="normal"
                            id={`startDay-${item.id}`}
                            label="Data de início das vendas"
                            format="DD/MM/YYYY"
                            value={item.startDate}
                            onChange={handleChangeDate('startDate', item.id)}
                            KeyboardButtonProps={{
                              'aria-label': 'change date'
                            }}
                          />
                        </MuiPickersUtilsProvider>
                      </div>
                      <div style={{ paddingLeft: 2 }}>
                        <MuiPickersUtilsProvider
                          libInstance={moment}
                          utils={MomentUtils}
                          locale="pt-br"
                        >
                          <KeyboardDatePicker
                            margin="normal"
                            id={`endDay-${item.id}`}
                            label="Data de final das vendas"
                            format="DD/MM/YYYY"
                            minDate={item.startDate}
                            minDateMessage="A Data final não pode ser inferior ao início."
                            value={item.endDate}
                            onChange={handleChangeDate('endDate', item.id)}
                            KeyboardButtonProps={{
                              'aria-label': 'change date'
                            }}
                          />
                        </MuiPickersUtilsProvider>
                      </div>
                    </div>
                    <div
                      className="col-6  d-flex flex-row justify-content-end align-items-center"
                      style={{ padding: 5 }}
                    >
                      <div>
                        <button type="button" onClick={handleAddItem} className="btn btn-primary">
                          Adicionar
                        </button>
                      </div>
                      <div style={{ paddingLeft: 5 }}>
                        <button
                          type="button"
                          onClick={() => handleDeleteItem(item.id)}
                          className="btn btn-danger"
                          disabled={eventsValuesList.length === 1}
                        >
                          Remover
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
      </div>
    </>
  )
}

export default EventsValuesData
